export const getUser = () => {
    const UserStr = localStorage.getItem("user");
    if (UserStr) return JSON.parse(UserStr);
    else return null;
}

export function getToken() {
    return localStorage.getItem("token") || null;
}
export const setToken = (token) => {
    localStorage.setItem("token", token);
}


export const setGlobalClientId = (clientId) => {
    localStorage.setItem("clientId", clientId);
}
export const getGlobalClientId = () => {
    return localStorage.getItem("clientId")?.split(",");
}


export const removeUserSession = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("clientId");
    localStorage.removeItem("status");
    localStorage.removeItem("email");
    localStorage.removeItem("status");
    localStorage.removeItem("LocalMenus");
    localStorage.removeItem("orgtype");
    localStorage.removeItem("orgId");
    localStorage.removeItem("isEmployee");
    localStorage.removeItem("name");
    localStorage.removeItem("incognitoEmail");
    localStorage.removeItem("InvitationURL");
    localStorage.removeItem("InvitationVendorId");
    localStorage.removeItem("InvitationIsMultiClient");
    localStorage.removeItem("InvitationPqid");
    localStorage.removeItem("InvitationClientId");
    localStorage.removeItem("view");
}

export const HasScreenPermissions = (ScreenName) => {
    const Permissions = getLocalMenus()?.flatMap((r) => r?.sideMenus);
    const Perm = Permissions?.flatMap((r) => r?.viewsAndPermissions)?.find((r) => r?.viewName == ScreenName);
    // console.log(Perm ? false : !Permissions.some((r) => r?.menuName == ScreenName));
    return Perm ? false : !Permissions.some((r) => r?.menuName == ScreenName);
}

export const HasDeletePermission = (ScreenName) => {
    const permissions = getLocalMenus()?.flatMap((r) => r?.sideMenus);
    const perm = permissions?.flatMap((r) => r?.viewsAndPermissions)?.find((r) => r?.viewName == ScreenName);
    if (perm != undefined && perm.viewPermission.indexOf("D") == -1) {
        return true;
    }
    return false;
};

export const getuserId = () => {
    return localStorage.getItem("user");
}


export const setstatuses = (status) => {
    return localStorage.setItem("status", JSON.stringify(status));
}
export const getstatuses = () => {
    return JSON.parse(localStorage.getItem("status"));
}
export const setviewallWidgit = (view) => {
    localStorage.setItem("view", view); // widget management
}
export const getviewallWidgit= () => {
    return localStorage.getItem("view")  // widget management
}
export const setLocalMenus = (menus) => {
    return localStorage.setItem("LocalMenus", JSON.stringify(menus));
}
export const getLocalMenus = () => {
    return JSON.parse(localStorage.getItem("LocalMenus"));
}

export const setOrgType = (orgtype) => {
    localStorage.setItem("orgtype", orgtype);
}
export const getOrgType = () => {
    return localStorage.getItem("orgtype");
}
export const setOrgId = (orgId) => {
    localStorage.setItem("orgId", orgId);
}
export const getOrgId = () => {
    return localStorage.getItem("orgId");
}
export const setisEmp = (isEmployee) => {
    localStorage.setItem("isEmployee", isEmployee);
}
export const getisEmp = () => {
    return localStorage.getItem("isEmployee");
}

export const setUserName = (name) => {
    localStorage.setItem("name", name);
}
export const getUserName = () => {
    return localStorage.getItem("name")?.split(",");
}

export const setEmail = (email) => {
    localStorage.setItem("email", email);
}
export const setIncognitoEmail = (incognitoEmail) => {
    localStorage.setItem("incognitoEmail", incognitoEmail);
};
export const getEmail = () => {
    return localStorage.getItem("email");
}

export const getIncognitoEmail = () => {
    return localStorage.getItem("incognitoEmail");
};
export const removeIncognitoEmail = () => {
    localStorage.removeItem("incognitoEmail");
};


export const setInvitationURL = (redirectionURL) => {
    localStorage.setItem("InvitationURL", redirectionURL);
}
export const getInvitationURL = () => {
    return localStorage.getItem("InvitationURL");
};
export const setInvitationVendorId = (InvitationVendorId) => {
    localStorage.setItem("InvitationVendorId", InvitationVendorId);
}
export const getInvitationVendorId = () => {
    return localStorage.getItem("InvitationVendorId");
};
export const setInvitationClientId = (InvitationClientId) => {
    localStorage.setItem("InvitationClientId", InvitationClientId);
}
export const getInvitationClientId = () => {
    return localStorage.getItem("InvitationClientId");
};
export const setInvitationIsMultiClient = (InvitationIsMultiClient) => {
    localStorage.setItem("InvitationIsMultiClient", InvitationIsMultiClient);
}
export const getInvitationIsMultiClient = () => {
    return localStorage.getItem("InvitationIsMultiClient");
};
export const setInvitationPqid = (InvitationPqid) => {
    localStorage.setItem("InvitationPqid", InvitationPqid);
}
export const getInvitationPqid = () => {
    return localStorage.getItem("InvitationPqid");
};


export const HasPermissions = (ScreenName, Permission) => {

    // const Permissions = getLocalMenus()?.find((r) => r?.actionName == ScreenName);
    // const Perm = Permissions?.sideMenus?.find((r) => r?.actionName == ScreenName);
    // if (Perm?.viewsAndPermissions[0]?.viewPermission.split('').find((r) => r == Permission)) return true
    // else return false;

    const Permissions = getLocalMenus()?.flatMap((r) => r?.sideMenus);
    const Perm = Permissions?.flatMap((r) => r?.viewsAndPermissions)?.find((r) => r?.viewName == ScreenName);
    // console.log(ScreenName);
    // console.log(Perm && Perm?.viewPermission?.indexOf(Permission) != -1);
    return Perm && Perm?.viewPermission?.indexOf(Permission) != -1;

}




// HasMainPermissions